import { Badge } from "antd"

export const ProformaPaymentStatus = ({ number }) => {
  const status = number
  switch (status) {
    case 0:
      return <Badge status="error" text="No Document" />
    case 1:
      return <Badge status="processing" text="Awaiting Payment" />
    case 2:
      return <Badge status="success" text="Paid" />
    default:
      return <Badge status="default" text="ERROR!" />
  }
}
